import { LoanApplicationTabName } from 'constants/loanApplication';

export const FIELDS_PARENT_TAB = LoanApplicationTabName.PROPERTY_AND_LOAN;
